import React, {useState, useEffect} from "react";
import {Redirect, Route} from "react-router";
import {useDispatch} from "react-redux";
import {fetchUser} from "../../reducers/auth";
import Loader from "../common/Loader/Loader";

const PrivateRoute = (props) => {
  const dispatch = useDispatch();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const { component: Component, ...rest } = props;



  useEffect(() => {
    const fetchData = async () => {
      dispatch(fetchUser())
        .then(result => {
          if (result) {
            setIsAuthenticated(true);
            setLoading(false);
          } else {
            setIsAuthenticated(false);
            setLoading(false);
          }
        })
        .catch(error => {
          setIsAuthenticated(false);
          setLoading(false);
        })
    };
    fetchData();
  }, [dispatch]);

  return (
    <Route
      {...rest}
      render={() =>
        isAuthenticated ? (
          <Component {...props} />
        ) : loading ? (
          <div style={{height: 1000}}>
            <Loader />
          </div>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
